import i18n from "@/i18n";
import { toaster } from "@/plugins/toaster.js";
import store from "@/store";

const checkIfSubscriptionExpired = () => {
  const storeInstance = store;
  const i18nInstance = i18n;

  const isLicenceValid = storeInstance?.getters?.isLicenceValid;
  const isOnPrem = storeInstance?.getters?.isOnPrem;

  if (!isLicenceValid && !isOnPrem) {
    const t = i18nInstance?.global?.t || i18nInstance?.t;
    toaster.error(t("common.label.subscription.expired"), {
      description: t("common.label.subscription.noActiveSubscription"),
      id: "subscription-expired",
      duration: Infinity,
    });

    return true;
  }

  return false;
};

export { checkIfSubscriptionExpired };
